import starsPointsAnimation from "../assets/starspoints.json";

const GOLD_FILL = [0.929000016755, 0.783999992819, 0.20800000359, 1];
const GOLD_STROKE = [0.854901960784, 0.828515385646, 0.107281808292, 1];
const WHITE_FILL = [1, 1, 1, 1];

function isCloseColor(a, b, tolerance = 0.02) {
  if (!Array.isArray(a) || !Array.isArray(b) || a.length < 3 || b.length < 3) return false;
  return (
    Math.abs(a[0] - b[0]) <= tolerance &&
    Math.abs(a[1] - b[1]) <= tolerance &&
    Math.abs(a[2] - b[2]) <= tolerance
  );
}

function hexToRgb(hex) {
  const normalized = hex.replace("#", "");
  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16),
  };
}

function stripWhiteBackgroundLayers(animation) {
  if (!animation || typeof animation !== "object") return;
  if (Array.isArray(animation.layers)) {
    animation.layers = animation.layers.filter((layer) => layer.ty !== 1);
  }
  if (Array.isArray(animation.assets)) {
    animation.assets.forEach((asset) => stripWhiteBackgroundLayers(asset));
  }
}

function replaceMatchingColors(node, fillColor, strokeColor) {
  if (!node || typeof node !== "object") return;

  if (node.ty === "fl" && node.c?.k && Array.isArray(node.c.k)) {
    if (isCloseColor(node.c.k, WHITE_FILL, 0.001)) {
      node.o = { a: 0, k: 0, ix: 5 };
    } else if (isCloseColor(node.c.k, GOLD_FILL)) {
      node.c.k = [...fillColor];
    } else if (isCloseColor(node.c.k, GOLD_STROKE)) {
      node.c.k = [...strokeColor];
    }
  }

  if (node.c?.k && Array.isArray(node.c.k) && node.ty !== "fl") {
    if (isCloseColor(node.c.k, GOLD_FILL)) {
      node.c.k = [...fillColor];
    } else if (isCloseColor(node.c.k, GOLD_STROKE)) {
      node.c.k = [...strokeColor];
    }
  }

  Object.values(node).forEach((value) => {
    if (Array.isArray(value)) {
      value.forEach((entry) => replaceMatchingColors(entry, fillColor, strokeColor));
    } else if (value && typeof value === "object") {
      replaceMatchingColors(value, fillColor, strokeColor);
    }
  });
}

function buildStarColorPair(hexColor) {
  const { r, g, b } = hexToRgb(hexColor);
  return {
    fillColor: [r / 255, g / 255, b / 255, 1],
    strokeColor: [(r / 255) * 0.82, (g / 255) * 0.82, (b / 255) * 0.82, 1],
  };
}

function replaceMatchingColorsDual(node, colorPairs, state = { index: 0 }) {
  if (!node || typeof node !== "object") return;

  const pickColors = () => {
    const pair = colorPairs[state.index % colorPairs.length];
    state.index += 1;
    return pair;
  };

  if (node.ty === "fl" && node.c?.k && Array.isArray(node.c.k)) {
    if (isCloseColor(node.c.k, WHITE_FILL, 0.001)) {
      node.o = { a: 0, k: 0, ix: 5 };
    } else if (isCloseColor(node.c.k, GOLD_FILL)) {
      const { fillColor } = pickColors();
      node.c.k = [...fillColor];
    } else if (isCloseColor(node.c.k, GOLD_STROKE)) {
      const { strokeColor } = pickColors();
      node.c.k = [...strokeColor];
    }
  }

  if (node.c?.k && Array.isArray(node.c.k) && node.ty !== "fl") {
    if (isCloseColor(node.c.k, GOLD_FILL)) {
      const { fillColor } = pickColors();
      node.c.k = [...fillColor];
    } else if (isCloseColor(node.c.k, GOLD_STROKE)) {
      const { strokeColor } = pickColors();
      node.c.k = [...strokeColor];
    }
  }

  Object.values(node).forEach((value) => {
    if (Array.isArray(value)) {
      value.forEach((entry) => replaceMatchingColorsDual(entry, colorPairs, state));
    } else if (value && typeof value === "object") {
      replaceMatchingColorsDual(value, colorPairs, state);
    }
  });
}

export function getColoredStarsAnimation(hexColor) {
  const { fillColor, strokeColor } = buildStarColorPair(hexColor);
  const clone = JSON.parse(JSON.stringify(starsPointsAnimation));
  stripWhiteBackgroundLayers(clone);
  replaceMatchingColors(clone, fillColor, strokeColor);
  return clone;
}

export function getDualColoredStarsAnimation(hexColorA, hexColorB) {
  const colorPairs = [buildStarColorPair(hexColorA), buildStarColorPair(hexColorB)];
  const clone = JSON.parse(JSON.stringify(starsPointsAnimation));
  stripWhiteBackgroundLayers(clone);
  replaceMatchingColorsDual(clone, colorPairs);
  return clone;
}

export function resolvePotionStarsAnimation(potion) {
  if (Array.isArray(potion?.starsColors) && potion.starsColors.length >= 2) {
    return getDualColoredStarsAnimation(potion.starsColors[0], potion.starsColors[1]);
  }
  return getColoredStarsAnimation(potion?.starsColor ?? potion?.themeColor ?? "#f8b320");
}
